import axios from 'axios';
import qs from 'qs';
import apiRequestHeaders from '../apiRequestHeaders';

const axiosInstance = axios.create({
  headers: {
    ...apiRequestHeaders.csrfHeader(),
    'Content-Type': 'application/json;charset=UTF-8',
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

axiosInstance.interceptors.request.use(config => {
  const activeSite = sessionStorage.getItem('activeSite');
  if (activeSite) {
    const [siteId] = activeSite.split(';');
    config.headers['X-Active-Site'] = siteId;
  }

  return config;
});

export default axiosInstance;
